import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import ProductUtils from 'helpers/ProductUtils';
import styles from 'styles/components/productdetail/price.scss';

const makePercentOff = (style, percentOffText, testId) => {
  const percentOff = ProductUtils.getPercentOff(style);
  if (percentOff > 0) {
    return (
      <span data-test-id={testId('percentOff')}>{percentOff}% {percentOffText}</span>
    );
  }
};

const Price = ({ productStyle, percentOffText, showPercentOffBanner }, { testId }) => {
  const showDiscount = ProductUtils.isStyleOnSale(productStyle);
  const percentOff = makePercentOff(productStyle, percentOffText, testId);

  return (
    <div>
      {showPercentOffBanner && (
        <span className={styles.percentOffBanner}>
          {percentOff}
        </span>
      )}
      <div className={styles.container}>
        <span className={cn(styles.price, { [styles.sale || '']: showDiscount })} data-test-id={testId('pdpProductPrice')}>{productStyle.price}</span>
        {showDiscount && (
          <span className={styles.discount}>
            {percentOff && (
              <span className={styles.percentOff}>
                {percentOff}
              </span>
            )}
            <span className={styles.originalPrice} data-test-id={testId('pdpOriginalPrice')}>
              {showDiscount && <span className={styles.msrp}>MSRP: </span>}
              <span data-test-id={testId('msrpPrice')}>{productStyle.originalPrice}</span>
            </span>
          </span>
        )}
      </div>
    </div>
  );
};

Price.propTypes = {
  productStyle: PropTypes.object.isRequired,
  percentOffText: PropTypes.string.isRequired,
  showPercentOffBanner: PropTypes.bool
};

Price.contextTypes = {
  testId: PropTypes.func
};

export default Price;
